import React from "react";
import { motion } from "framer-motion";
import "./ProfileSkeleton.css";

const shimmer = {
  initial: { x: "-100%" },
  animate: {
    x: "100%",
    transition: {
      repeat: Infinity,
      duration: 1.5,
      ease: "linear",
    },
  },
};

const SkeletonLine = ({ width = "100%", height = "16px", className = "" }) => (
  <div className={`prf-skeleton-line ${className}`} style={{ width, height }}>
    <motion.div
      className="prf-skeleton-shimmer"
      variants={shimmer}
      initial="initial"
      animate="animate"
    />
  </div>
);

const ProfileSkeleton = () => {
  return (
    <div className="prf-skeleton">
      {/* Header Section */}
      <div className="prf-skeleton-header">
        <div className="prf-skeleton-bg" />

        <div className="prf-skeleton-content">
          {/* Avatar Section */}
          <div className="prf-skeleton-avatar-section">
            <div className="prf-skeleton-avatar">
              <motion.div
                className="prf-skeleton-shimmer"
                variants={shimmer}
                initial="initial"
                animate="animate"
              />
            </div>
            <div className="prf-skeleton-quick-stats">
              {[1, 2, 3].map((i) => (
                <div key={i} className="prf-skeleton-stat">
                  <SkeletonLine width="40px" height="18px" />
                  <SkeletonLine width="50px" height="12px" />
                </div>
              ))}
            </div>
          </div>

          {/* Info Section */}
          <div className="prf-skeleton-info">
            <div className="prf-skeleton-name-row">
              <SkeletonLine width="200px" height="28px" />
              <SkeletonLine width="100px" height="24px" />
            </div>
            <SkeletonLine width="250px" height="16px" />
            <div className="prf-skeleton-tags">
              <SkeletonLine width="80px" height="26px" />
              <SkeletonLine width="60px" height="26px" />
              <SkeletonLine width="70px" height="26px" />
            </div>
            <div className="prf-skeleton-contact">
              <SkeletonLine width="120px" height="14px" />
              <SkeletonLine width="100px" height="14px" />
            </div>
          </div>

          {/* Actions Section */}
          <div className="prf-skeleton-actions">
            <SkeletonLine width="120px" height="40px" />
            <SkeletonLine width="120px" height="40px" />
            <SkeletonLine width="120px" height="40px" />
          </div>
        </div>

        {/* Stats Bar */}
        <div className="prf-skeleton-stats-bar">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="prf-skeleton-stat-card">
              <SkeletonLine width="40px" height="24px" />
              <SkeletonLine width="60px" height="12px" />
            </div>
          ))}
        </div>
      </div>

      {/* Tabs Section */}
      <div className="prf-skeleton-tabs">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <SkeletonLine key={i} width="80px" height="40px" />
        ))}
      </div>

      {/* Content Section */}
      <div className="prf-skeleton-body">
        <div className="prf-skeleton-grid">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <motion.div
              key={i}
              className="prf-skeleton-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
            >
              <SkeletonLine width="100%" height="20px" />
              <SkeletonLine width="80%" height="14px" />
              <SkeletonLine width="60%" height="14px" />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileSkeleton;
